import { api } from '../AppConfig';
import * as Setting from '../utils/AuthUtils';
import { connect, catch401s, getToken } from './utils';

const getDeck = (resolve, reject, id) => () => {
    return {
      deck: {
        url: api.decks().detailsById(id).href,
        then: resolve,
        catch: reject,
        refreshing: true,
        force: true,
      }
    }
  }

const ajaxDeck = connect(({id}) => ({
    deck: {
        url: api.decks().detailsById(id).href,
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        // andThen: season => { return { stages: api.seasons().getStages(id).href, ranking: api.seasons().getRanking(id).href, metagame: api.seasons().getMetagame(id).href}},
        catch: catch401s,
    },
}));

export default ajaxDeck;